import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, Group, Image, Text } from '@mantine/core';
import { CategoriesCards } from '../Shares/CategoryCards';
import { InfoHistoryTable } from './InfoHistoryTable';
import { statistics } from './data';
export const InfoStatistic: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card mt={{
    base: 16,
    sm: 20
  }} p={{
    base: 10,
    sm: 20
  }} bg="var(--navbar-bg-color)">
      <Group align="center" gap={4}>
        <Text fz={18} className={gunterzBold.className} c="var(--text-prime)">
          {i18n._('Stats')}
        </Text>
        <Image src="/assets/title-icons/12.png" w={40} h={40} alt="icon" mb={8} />
      </Group>

      <CategoriesCards items={statistics} span={{
      base: 6,
      sm: 3
    }} />

      <InfoHistoryTable />
    </Card>;
};